import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: '15px' // Match the actual JobTable spacing
  },
  jobRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default'
    }
  },
  jobAvatar: {
    display: 'flex',
    alignItems: 'center'
  },
  jobDetails: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  avatarSkeleton: {
    marginRight: theme.spacing(3)
  },
  jobRowContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1.5)
  },
  timeAgo: {
    marginLeft: 'auto',
    paddingLeft: theme.spacing(2),
    width: '100%',
    maxWidth: '120px',
    textAlign: 'right',
    height: '85px' // Match the actual timeAgoLabel height
  }
}));

const JobListSkeleton = ({ count = 3 }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CardContent className={classes.content}>
        <Table className={classes.table}>
          <TableBody>
            {[...Array(count)].map((_, index) => (
              <TableRow key={index} hover={false}>
                <TableCell>
                  <div className={classes.jobRowContent}>
                    {/* Avatar Skeleton */}
                    <Skeleton
                      variant="circle"
                      width={50}
                      height={50}
                      className={classes.avatarSkeleton}
                      animation="wave"
                    />

                    {/* Job Details Skeleton */}
                    <div className={classes.jobDetails}>
                      {/* Company Name */}
                      <Skeleton
                        variant="text"
                        width={180}
                        height={20}
                        animation="wave"
                      />

                      {/* Job Title */}
                      <Skeleton
                        variant="text"
                        width={280}
                        height={28}
                        animation="wave"
                      />

                      {/* Job Type/Category Chips */}
                      <Box display="flex" gap={1}>
                        <Skeleton
                          variant="rect"
                          width={100}
                          height={24}
                          style={{ borderRadius: 12 }}
                          animation="wave"
                        />
                        <Skeleton
                          variant="rect"
                          width={80}
                          height={24}
                          style={{ borderRadius: 12 }}
                          animation="wave"
                        />
                      </Box>
                    </div>

                    {/* Time Ago Skeleton - in same row */}
                    <div className={classes.timeAgo}>
                      <Skeleton
                        variant="text"
                        width={100}
                        height={20}
                        animation="wave"
                      />
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </div>
  );
};

export default JobListSkeleton;
